import { render, staticRenderFns } from "./gridtableForm.vue?vue&type=template&id=5dfc6e8a&"
import script from "./gridtableForm.vue?vue&type=script&lang=js&"
export * from "./gridtableForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports